import React, { useCallback, useEffect, useState } from "react";
import { apiUrl } from "../../config/api";
import "./tableeAdmin.css";

function getSessionHeaders() {
  const session = JSON.parse(localStorage.getItem("sessionData") || "{}");
  return {
    Authorization: session.sessionKey || "",
    Username: session.username || "",
  };
}

function formatMoney(value) {
  return Number(value || 0).toLocaleString("es-CL", {
    style: "currency",
    currency: "CLP",
    maximumFractionDigits: 0,
  });
}

function formatDate(value) {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("es-CL");
}

function getDisplayName(customer) {
  if (customer.clientType === "empresa") return customer.companyName || customer.name;
  return [customer.firstName, customer.lastName].filter(Boolean).join(" ") || customer.name;
}

function TableeCustomers({ apiPrefix = "/tablee", storeName = "Tablee", storeLogo = "/images/tablee_logo.png", storeUrl = "www.tablee.cl" } = {}) {
  const [customers, setCustomers] = useState([]);
  const [message, setMessage] = useState("");

  const loadCustomers = useCallback(async () => {
    const response = await fetch(apiUrl(`${apiPrefix}/customers`), {
      headers: getSessionHeaders(),
    });
    const data = await response.json();
    if (data.success) {
      setCustomers(data.customers || []);
    } else {
      setMessage(data.message || "No se pudieron cargar los usuarios.");
    }
  }, [apiPrefix]);

  useEffect(() => {
    loadCustomers();
  }, [loadCustomers]);

  return (
    <section className="tablee-admin tablee-admin__customers">
      <header className="tablee-admin__header">
        <img src={storeLogo} alt={storeName} />
        <div>
          <span>{storeName}</span>
          <h1>Usuarios ecommerce</h1>
          <p>Consulta las cuentas registradas desde {storeUrl}.</p>
        </div>
      </header>

      <div className="tablee-admin__panel">
        <div className="tablee-admin__panel-head">
          <div>
            <span>Usuarios</span>
            <h2>Clientes registrados</h2>
          </div>
          <strong>{customers.length} usuarios</strong>
        </div>
        <div className="tablee-admin__table">
          <div className="tablee-admin__table-head" aria-hidden="true">
            <span>Usuario</span>
            <span>Email</span>
            <span>Tipo</span>
            <span>Telefono</span>
            <span>Pedidos</span>
            <span>Total</span>
            <span>Creado</span>
          </div>
          {customers.length ? customers.map((customer) => (
            <article className="tablee-admin__table-row" key={customer.id}>
              <div className="tablee-admin__main-cell">
                <strong>{getDisplayName(customer)}</strong>
                <small>{customer.rut || customer.createdIn}</small>
              </div>
              <span>{customer.email}</span>
              <span className="tablee-admin__status">{customer.clientType === "empresa" ? "Empresa" : "Persona"}</span>
              <span>{customer.phone || "-"}</span>
              <strong>{customer.orderCount || 0}</strong>
              <strong>{formatMoney(customer.totalSpent)}</strong>
              <span className="tablee-admin__muted">{formatDate(customer.createdAt)}</span>
            </article>
          )) : (
            <p className="tablee-admin__empty">{message || "No hay usuarios registrados."}</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default TableeCustomers;
